<template>
  <v-skeleton-loader v-if="isLoadingAsyncData" type="article" />
  <LKPublicationsContainer v-else-if="isContainerVisible" title="Сбор данных">
    <template v-if="list && list.length">
      <LKPublicationsDataCollection
        v-for="item in list"
        :key="item.id"
        :data="item"
        :publication-id="publicationId"
        class="LKPublicationsDataCollectionList__item"
        v-on="$listeners"
      />
    </template>
    <template v-else-if="errorMessage">
      <div
        class="error--text ml-8"
        v-text="errorMessage"
      />
      <v-btn
        dark
        block
        depressed
        :color="color"
        @click.stop="getData"
        v-text="'Повторить'"
      />
    </template>
  </LKPublicationsContainer>
</template>

<script>
import LKPublicationsContainer from './LKPublicationsContainer.vue'
import LKPublicationsDataCollection from './LKPublicationsDataCollection/LKPublicationsDataCollection.vue'
import PublicationsCardComponentMixin
  from '@/views/LKPublications/components/LKPublicationsCard/PublicationsCardComponentMixin'
import { LkPublicationsApi } from '@/api/resources'

export default {
  name: 'LKPublicationsDataCollectionList',
  apiMethodName: 'getDataCollections',
  components: {
    LKPublicationsContainer,
    LKPublicationsDataCollection,
  },
  mixins: [PublicationsCardComponentMixin],
  methods: {
    async loadData() {
      const api = new LkPublicationsApi()
      const { data } = await api.getDataCollections(this.publicationId)
      return data
    },
  },

}
</script>

<style lang="scss">
.LKPublicationsDataCollectionList {
  &__item {
    margin-bottom: 12px;
  }
}
</style>
